import React, { useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import styled from "styled-components";
import Icon from "@material-ui/core/Icon";

export const ChangeEditors = ({
  validMissionMakers,
  editors,
  setEditors,
  username,
}) => {
  const [inputValue, setInputValue] = useState("");
  return (
    <Container>
      <Typography variant="h5" component="h3">
        EDITORS
      </Typography>
      <div>
        These are the current people who are able to edit your mission. By
        default only you can and administrator accounts can edit your missions.
        <p>You can add/remove people from this list below.</p>
      </div>
      <Wrapper>
        <StyledAutoComplete
          onChange={(_, newValue) => {
            const tmp = editors;
            if (newValue && !tmp.includes(newValue)) {
              tmp.push(newValue);
              setEditors(tmp);
            }
          }}
          inputValue={inputValue}
          onInputChange={(_, newInputValue) => {
            setInputValue(newInputValue);
          }}
          id="controllable-states-demo"
          options={validMissionMakers}
          style={{ width: 300 }}
          renderInput={(params) => (
            <TextField {...params} label="Type here..." variant="outlined" />
          )}
        />
        <div>
          {editors.map((i) => {
            if (i === "administrator" || i === username) {
              return (
                <StyledListItem disabled>
                  <div>{i}</div>
                  <Icon color="primary">cancel</Icon>
                </StyledListItem>
              );
            }
            return (
              <StyledListItem
                onClick={() => {
                  const tmp = editors.filter((item) => item !== i);
                  setEditors(tmp);
                }}
              >
                <div>{i}</div>
                <Icon color="primary">cancel</Icon>
              </StyledListItem>
            );
          })}
        </div>
      </Wrapper>
    </Container>
  );
};

const Wrapper = styled.div`
  display: flex;
`;

const StyledListItem = styled.div`
  height: 30px;
  width: 150px;
  border: 2px solid #3f51b5;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  margin: 10px;
  > div {
    color: black;
  }
  ${({ disabled }) => {
    return disabled && `cursor: no-drop;`;
  }}
`;

const StyledAutoComplete = styled(Autocomplete)`
  display: flex;
  justify-content: center;
  padding: 25px;
`;

const Container = styled.div`
  width: 100%;
  background: #36393f;
  border-radius: 5px;
  padding: 10px;
`;

export default ChangeEditors;
